import { ResolveFn, Router } from '@angular/router';
import { ConsultancyService } from '../dashboard/services/consultancy.service';
import { inject } from '@angular/core';
import { catchError, EMPTY } from 'rxjs';

export const consultanciesResolver: ResolveFn<any> = (route, state) => {
  const service = inject(ConsultancyService);
  const router = inject(Router);
  
  return service.getApprovedConsultancies({ limit: 8 }).pipe(
    catchError((error) => {
      console.error('Resolver error:', error);

      // Redirect to 404 page
      router.navigate(['/not-found']);

      return EMPTY;
    })
  );
};
